



































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import StarRating from '@/components/StarRating.vue';
import { analytics } from '@/lib/util/FirebaseConfig';
import { db } from '@/lib/ProductDatabase';
import { kioskSetup } from '@/lib/KioskSetup';
import { $nav } from '@/lib/KioskNavigation';
import IProduct from '@/lib/IProduct';
import _ from 'lodash';
import Lockr from 'lockr';
import ITopic from '../lib/ITopic';

@Component({
  components: {
    StarRating,
  },
})
export default class Products extends Vue {

  // reactive properties
  products: IProduct[] = [];
  activeTopics: any = {};

  // injected properties
  @Prop({ required: false }) topicId!: string | null; // initial active topic

  // non-reactive properties

  // lifecycle
  created() {
    this.products = db.getAllProducts();
    if ( this.topicId ) {
      this.enableTopic(this.topicId);
    }
    else {
      this.enableAllTopics();
    }
  }

  // computed
  get topics(): ITopic[] {
    return db.getAllTopics();
  }

  get topicNames(): string[] {
    return _.map(db.getAllTopics(), (topic) => topic.name);
  }

  get topicIds() {
    return _.map(db.getAllTopics(), (topic) => topic.id);
  }

  get activeTopicIdList(): string[] {
    return _.filter(_.keys(this.activeTopics), (id) => !!this.activeTopics[id]);
  }

  get filteredProducts(): IProduct[] {
    if ( this.isActiveTopic('all') ) {
      return this.products;
    }

    // console.log(`activeTopics=`);
    // _.keys(this.activeTopics).forEach((k) => { console.log(`  ${k}`); });
    const list = _.filter(this.products, (p) => {
      const hasMatch = _.intersection(p.topicIds, this.activeTopicIdList).length > 0;
      // console.log(`productId=${p.id} hasMatch=${hasMatch}`);
      return hasMatch;
    });
    // console.log("filtered list = ", list);
    // always return something
    return ( list.length > 0 ) ? list : this.products;
  }

  get productCount(): number {
    return this.filteredProducts.length;
  }

  get whitelabelPath(): string {
    return db.getWhitelabelPath();
  }

  // methods
  formattedPrice(priceInCents: number): string {
    const dollars = Math.floor(priceInCents / 100);
    const cents = priceInCents - (dollars * 100);
    return '$' + dollars + '.' + ((cents < 10) ? '0' : '') + cents;
  }

  toggleTopic(event: any, topicId: string) {
    //console.log(event);
    event.target.blur();
    if ( 'all' === topicId ) {
      if ( this.isActiveTopic('all') ) {
        this.disableAllTopics();
      }
      else {
        this.enableAllTopics();
      }
    }
    else {
      this.disableAllTopics();
      Vue.set(this.activeTopics, topicId, !this.activeTopics[topicId]);
    }
  }

  enableTopic(topicId: string) {
    Vue.set(this.activeTopics, topicId, true);
  }

  disableTopic(topicId: string) {
    Vue.set(this.activeTopics, topicId, false);
  }

  enableAllTopics() {
    this.topicIds.forEach( (topicId) => {
        this.enableTopic(topicId);
    });
  }

  disableAllTopics() {
    this.topicIds.forEach( (topicId) => {
        this.disableTopic(topicId);
    });
  }

  isActiveTopic(topicId: string): boolean {
    if ( 'all' === topicId ) {
      let isAllActive = true;
      this.topicIds.forEach( (id) => {
        isAllActive = isAllActive && !!this.activeTopics[id];
      });
      return isAllActive;
    }
    else {
      return !!this.activeTopics[topicId];
    }
  }

  btnBack() {
    $nav.back(this);
  }

  btnClickProduct(productId: number) {
    const product = db.getProductById(productId);
    if ( product ) {
      console.log(`btnClickProduct id=${product.id} name=${product.name}`);
      analytics.logEvent("view_item", { kioskId: kioskSetup.kioskId, items: [{name: product.name, id: String(product.id)}] });
    }
    $nav.to(this, '/product-detail/' + productId);
  }

}

